import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './i18n';
import { BrowserRouter } from 'react-router-dom';

import {
 ApolloProvider,
 ApolloClient,
 HttpLink,
 InMemoryCache,
 DefaultOptions,
} from '@apollo/client';

const root = ReactDOM.createRoot(
 document.getElementById('root') as HTMLElement
);

const cache = new InMemoryCache();

const httpLink = new HttpLink({
 uri: process.env.REACT_APP_SMS_SERVICE_URL,
});

const defaultOptions: DefaultOptions = {
 watchQuery: {
  fetchPolicy: 'no-cache',
  errorPolicy: 'ignore',
 },
 query: {
  fetchPolicy: 'no-cache',
  errorPolicy: 'all',
 },
};

const client = new ApolloClient({
 link: httpLink,
 cache: cache,
 defaultOptions: defaultOptions,
});

root.render(
 <BrowserRouter>
  <ApolloProvider client={client}>
   <Provider store={store}>
    <App />
   </Provider>
  </ApolloProvider>
 </BrowserRouter>
);
